// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_wrapper {
  width: 90%;
  margin: 0 auto;
  padding: 10px 0;
}
.layout_wrapper {
  padding-top: 90px;
  overflow: hidden;
}
@media screen and (max-width: 700px) {
  .layout_wrapper {
    padding-top: 50px;
  }
}
.filter_wrapper {
  border-bottom: 1px solid rgba(0, 0, 0, 0.142);
  padding: 10px;
  background: rgba(255, 255, 255, 0.46);
}

.filter {
  width: 90%;
  display: flex;
  align-items: end;
  gap: 20px;
  margin: 0 auto;
  flex-wrap: wrap;
}
@media screen and (max-width: 900px) {
  .filter {
    width: 100%;
    gap: 10px;
  }
}
.search_button {
  background: #27292f;
  padding: 8px 30px;
  color: white;
  height: max-content;
  border: 1px solid #27292f;
  border-radius: 5px;
  font-weight: 500;
  letter-spacing: 0.2px;
  font-size: 13px;
}
.search_button:hover {
  background: transparent;
  color: #27292f;
}
.disabled_button:hover {
  background: #27292f;
  color: white;
  cursor: not-allowed;
}
.form-control {
  height: 37px;
  font-size: 14px;
}
.mySelect__value-container {
  height: 30px;
  font-size: 14px;
}
.react-select__value-container {
  height: 20px;
}
.css-13cymwt-control {
  min-height: 30px !important;
  padding: 0 4px;
}
.css-1dimb5e-singleValue {
  margin-bottom: 5px;
}
.css-1xc3v61-indicatorContainer {
  padding: 0;
  margin-bottom: 0;
}
label {
  font-size: 10px;
}
.title {
  font-size: 22px;
  font-weight: 600;
}
.subtitle {
  font-size: 16px;
  font-weight: 600;
}
.title_second {
  font-size: 20px;
  font-weight: 500;
  opacity: 0.7;
  font-family: sans-serif;
}
.css-1nmdiq5-menu {
  z-index: 10 !important;
}
@media screen and (max-width: 900px) {
  .container_wrapper {
    width: 98%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Admin/index.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,6CAA6C;EAC7C,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE;IACE,WAAW;IACX,SAAS;EACX;AACF;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".container_wrapper {\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  padding: 10px 0;\r\n}\r\n.layout_wrapper {\r\n  padding-top: 90px;\r\n  overflow: hidden;\r\n}\r\n@media screen and (max-width: 700px) {\r\n  .layout_wrapper {\r\n    padding-top: 50px;\r\n  }\r\n}\r\n.filter_wrapper {\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.142);\r\n  padding: 10px;\r\n  background: rgba(255, 255, 255, 0.46);\r\n}\r\n\r\n.filter {\r\n  width: 90%;\r\n  display: flex;\r\n  align-items: end;\r\n  gap: 20px;\r\n  margin: 0 auto;\r\n  flex-wrap: wrap;\r\n}\r\n@media screen and (max-width: 900px) {\r\n  .filter {\r\n    width: 100%;\r\n    gap: 10px;\r\n  }\r\n}\r\n.search_button {\r\n  background: #27292f;\r\n  padding: 8px 30px;\r\n  color: white;\r\n  height: max-content;\r\n  border: 1px solid #27292f;\r\n  border-radius: 5px;\r\n  font-weight: 500;\r\n  letter-spacing: 0.2px;\r\n  font-size: 13px;\r\n}\r\n.search_button:hover {\r\n  background: transparent;\r\n  color: #27292f;\r\n}\r\n.disabled_button:hover {\r\n  background: #27292f;\r\n  color: white;\r\n  cursor: not-allowed;\r\n}\r\n.form-control {\r\n  height: 37px;\r\n  font-size: 14px;\r\n}\r\n.mySelect__value-container {\r\n  height: 30px;\r\n  font-size: 14px;\r\n}\r\n.react-select__value-container {\r\n  height: 20px;\r\n}\r\n.css-13cymwt-control {\r\n  min-height: 30px !important;\r\n  padding: 0 4px;\r\n}\r\n.css-1dimb5e-singleValue {\r\n  margin-bottom: 5px;\r\n}\r\n.css-1xc3v61-indicatorContainer {\r\n  padding: 0;\r\n  margin-bottom: 0;\r\n}\r\nlabel {\r\n  font-size: 10px;\r\n}\r\n.title {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n}\r\n.subtitle {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n.title_second {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  opacity: 0.7;\r\n  font-family: sans-serif;\r\n}\r\n.css-1nmdiq5-menu {\r\n  z-index: 10 !important;\r\n}\r\n@media screen and (max-width: 900px) {\r\n  .container_wrapper {\r\n    width: 98%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
